export default __webpack_public_path__ + "static/media/leather-shoes.a61cc726.jpeg";